/**
 * A measure in a sentence of the record (CI §4, UX-Gutachten 1, B-18): a
 * number in German grouping („1.100", „12.000", „5.200,5") with or without
 * its unit, or any number with one („300 mm", „4,20 m"). Not a count
 * („5 Planstände"), a stage or page number („Stand 3", „Seite 2"), a date
 * („21.10.2026"), a Vorgang's number („2026-0014") or an amount („2.967,10 €"):
 * the record writes those in the UI face (`.tabular`).
 */
const MEASURE =
  /(?<![\p{L}\d.,])(?:\d{1,3}(?:\.\d{3})+(?:,\d+)?(?:\s?(?:mm|cm|m)(?!\p{L}))?|\d+(?:,\d+)?\s?(?:mm|cm|m)(?!\p{L}))(?![\d.,]*\d)(?!\s?€)/gu;

/**
 * A sentence cut where it names a measure, every character kept and in its
 * order — so a line can set the measures in mono (`.num`) and leave the
 * server's words as they are.
 */
export function measureParts(text: string): { text: string; measure: boolean }[] {
  const parts: { text: string; measure: boolean }[] = [];
  let from = 0;
  for (const match of text.matchAll(MEASURE)) {
    if (match.index > from) parts.push({ text: text.slice(from, match.index), measure: false });
    parts.push({ text: match[0], measure: true });
    from = match.index + match[0].length;
  }
  if (from < text.length) parts.push({ text: text.slice(from), measure: false });
  return parts;
}
